export default "__VITE_ASSET__CZQajnkE__"